import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { reactive, computed, ref } from "vue"
  import PButton from "primevue/button"
  import { MModalDeAlerta, IAlertaMensagem } from "@/components/Gerais"
  import AtividadesRealizadasRepositorio from "@/repositorios/atividades/atividades.repositorio"
  import { useToast } from "primevue/usetoast"
  import { MensagemErro } from "@/repositorios/erros"
  import { Anulavel } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    modelValue: boolean
    idDoEvento: string
    modoDeRegistro: string
    nomeProfissional: string
    nomeAtividade: string
    dataPorExtensoInicio: string
    dataPorExtensoFim: string
    teleportarPara?: "self" | "body"
  }

  interface AlertaComReset extends IAlertaMensagem {
    icone: string
    modelValue: boolean
    legendaBotaoConcordar: string
    legendaBotaoNeutro: string
    legendaBotaoDiscordar: string
    acaoBotaoConcordar: Anulavel<() => Promise<void>>
    $reset(): void
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OModalExcluirAtividade',
  props: {
    modelValue: { type: Boolean },
    idDoEvento: null,
    modoDeRegistro: null,
    nomeProfissional: null,
    nomeAtividade: null,
    dataPorExtensoInicio: null,
    dataPorExtensoFim: null,
    teleportarPara: null
  },
  emits: ["update:modelValue", "onRecarregarAtividades"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:modelValue", modelValue: boolean): void
    (event: "onRecarregarAtividades"): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    modelValue: boolean
    idDoEvento: string
    modoDeRegistro: string
    nomeProfissional: string
    nomeAtividade: string
    dataPorExtensoInicio: string
    dataPorExtensoFim: string
    teleportarPara?: "self" | "body"
  }

  

  const estaCarregando = ref(false)

  const toast = useToast()

  
  const emitirModel = computed({
    get(): boolean {
      return props.modelValue
    },
    set(value: boolean) {
      emitir("update:modelValue", value)
    },
  })

  const { t } = useI18n()

  const atividadesRealizadasRep = new AtividadesRealizadasRepositorio()

  const objetoDialogExcluir = {
    titulo: t("deletarAtividade"),
    legendaBotaoConcordar: t("simDeletar"),
    conteudo: "",
    acaoBotaoConcordar: async () => {
      try {
        await atividadesRealizadasRep.deletarAtividade({ id: props.idDoEvento })
        toast.add({
          severity: "success",
          summary: t("atividade deletada"),
          detail: `${props.nomeAtividade} ${t("por")} ${props.nomeProfissional}`,
          life: 5000,
          closable: true,
        })
        emitir("onRecarregarAtividades")
      } catch (erro: any) {
        const error = erro as MensagemErro
        toast.add({
          severity: "error",
          summary: t("atividadeNaoDeletada"),
          detail: error.detalhe,
          life: 5000,
          closable: true,
        })
      }
    },
  }

  const objetoDialogDesconsiderar = {
    titulo: t("desconsiderarAtividade"),
    legendaBotaoConcordar: t("simDesconsiderar"),
    conteudo: "",
    acaoBotaoConcordar: async () => {
      try {
        await atividadesRealizadasRep.desconsiderarAtividade({
          id: props.idDoEvento,
        })
        toast.add({
          severity: "success",
          summary: t("atividadeDesconsiderada"),
          life: 5000,
          closable: true,
        })
        emitir("onRecarregarAtividades")
      } catch (erro) {
        toast.add({
          severity: "error",
          summary: t("atividadeNaoDesconsiderada"),
          detail: erro,
          life: 5000,
          closable: true,
        })
      }
    },
  }

  const complementoBaseadoNaAcao =
    props.modoDeRegistro === "desconsiderar"
      ? objetoDialogDesconsiderar
      : objetoDialogExcluir

  const verboDaAcao = computed(() => {
    return props.modoDeRegistro === "desconsiderar"
      ? "desconsiderar"
      : "excluir"
  })

  let objetoDialog = reactive<AlertaComReset>({
    icone: "pi pi-exclamation-triangle",
    tipo: "atencao",
    modelValue: props.modelValue,
    legendaBotaoNeutro: "voltar",
    legendaBotaoDiscordar: "",
    visivel: false,
    ...complementoBaseadoNaAcao,
    $reset: function () {
      emitir("update:modelValue", false)
    },
  })

  const fecharModal = () => {
    objetoDialog.$reset()
  }

  const dispararAcaoBotaoConcordar = async () => {
    estaCarregando.value = true
    if (typeof objetoDialog.acaoBotaoConcordar === "function") {
      await objetoDialog.acaoBotaoConcordar()
    }
    fecharModal()
    estaCarregando.value = false
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MModalDeAlerta), {
    modelValue: _unref(emitirModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirModel) ? (emitirModel).value = $event : null)),
    cabecalho: _unref(objetoDialog).titulo,
    conteudo: _unref(objetoDialog).conteudo,
    "data-testid": "OModalExcluirAtividade",
    "teleportar-para": __props.teleportarPara,
    tipo: _unref(objetoDialog).tipo
  }, {
    acoes: _withCtx(() => [
      _createVNode(_unref(PButton), {
        onClick: fecharModal,
        class: "Modal__Button p-button-text p-button-info",
        label: _unref(objetoDialog).legendaBotaoNeutro
      }, null, 8, ["label"]),
      _createVNode(_unref(PButton), {
        onClick: dispararAcaoBotaoConcordar,
        class: "Modal__Button p-button-danger",
        "data-testid": "OModalExcluirAtividade__Concordar",
        label: _unref(objetoDialog).legendaBotaoConcordar,
        loading: estaCarregando.value
      }, null, 8, ["label", "loading"])
    ]),
    conteudo: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(`${_unref(t)('temCertezaQueDeseja')} ${_unref(verboDaAcao)} ${_unref(t)('seguinteAtividade')}`), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(__props.nomeAtividade) + ", " + _toDisplayString(_unref(t)('por')) + " " + _toDisplayString(__props.nomeProfissional), 1)
      ]),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_unref(t)('iniciadaEm')) + " " + _toDisplayString(__props.dataPorExtensoInicio) + ", " + _toDisplayString(_unref(t)('encerradaEm')) + " " + _toDisplayString(__props.dataPorExtensoFim), 1)
      ]),
      (__props.modoDeRegistro === 'desconsiderar')
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('aoDesconsiderarAtividade')), 1),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, _toDisplayString(_unref(t)('ela não será mais visível no calendário')), 1),
              _createElementVNode("li", null, _toDisplayString(_unref(t)('suasHorasNaoContaraoParaTotalDeHorasDoProfissional')), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)('aoDeletarAtividadeElaSeraPermanentementeExcluida')), 1)
          ]))
    ]),
    _: 1
  }, 8, ["modelValue", "cabecalho", "conteudo", "teleportar-para", "tipo"]))
}
}

})